module.exports = __webpack_public_path__ + "img/play.70c514ce.png";